import { useFirstPostSurvey } from 'src/components/communitySurvey/hooks/useFirstPostSurvey'
import { useSecondPostSurvey } from 'src/components/communitySurvey/hooks/useSecondPostSurvey'

const usePostSurvey = () => {
  const { setIsFirstPostSurveyOpen, FIRST_POST_SURVEY_KEY } = useFirstPostSurvey()
  const { setIsSecondPostSurveyOpen, THIRD_POST_SURVEY_KEY } = useSecondPostSurvey()

  const onSurveyInit = () => {
    const isFirstPostSurveyAnswered = localStorage.getItem(FIRST_POST_SURVEY_KEY) === 'true'
    const isSecondPostIsFirstPostAnswered = localStorage.getItem(THIRD_POST_SURVEY_KEY) === 'true'

    if (isFirstPostSurveyAnswered && isSecondPostIsFirstPostAnswered) return

    if (!isFirstPostSurveyAnswered) {
      setIsFirstPostSurveyOpen(true)

      return
    }

    if (localStorage.getItem(THIRD_POST_SURVEY_KEY) === null) {
      localStorage.setItem(THIRD_POST_SURVEY_KEY, 'false')

      return
    }

    setIsSecondPostSurveyOpen(true)
  }

  return { onSurveyInit }
}

export default usePostSurvey
